import React, { useEffect, useRef, useState } from 'react'
import { Form, App, Modal, Popconfirm } from 'antd'
import { useFeiyongTypeAddMutation, useFeiyongTypeDelMutation, useFeiyongTypeListQuery, useFeiyongTypeUpdateSaveMutation } from '../../store/NeiZhangFeiYongApi';
import { EditableProTable } from '@ant-design/pro-components';

function ExpenseTypeEdit(props) {
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const { data, isSuccess, refetch } = useFeiyongTypeListQuery(
        { fyt_qy_id: props.e_id },
        { skip: !open }
    );

    const [dataSource, setDataSource] = useState([]);
    const actionRef = useRef();
    const [editableKeys, setEditableRowKeys] = useState([]);
    const [form] = Form.useForm();

    // 初始化数据
    useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            const formattedData = data.Result.map(item => ({
                key: item.fyt_id.toString(),  // 确保key是字符串
                title: item.fyt_name,
                fyt_tag: item.fyt_tag,
                fyt_uname: item.fyt_uname,
                fyt_ctime: item.fyt_ctime,
                originalData: item  // 保留原始数据
            }));
            const sortedData = formattedData.sort((a, b) => new Date(a.fyt_ctime) - new Date(b.fyt_ctime));
            setDataSource(sortedData);
        }
    }, [data, isSuccess]);

    // 删除记录
    const handleDelete = async (record) => {
        try {
            const res = await del({ fyt_id: record.key });
            if (res.data?.Status === 'success') {
                message.success('删除成功');
                refetch();
            } else {
                message.error('删除失败: ' + (res.data?.Message || ''));
            }
        } catch (error) {
            message.error('删除失败: ' + error.message);
        }
    };

    const [add] = useFeiyongTypeAddMutation();
    const [updateSave] = useFeiyongTypeUpdateSaveMutation();
    const [del] = useFeiyongTypeDelMutation();

    const columns = [
        {
            title: '报销类型',
            dataIndex: 'title',
            formItemProps: { 
                rules: [{ required: true, message: '必填项' }] 
            },
        },
        {
            title: '操作',
            valueType: 'option',
            render: (text, record, _, action) => {
                if (record.fyt_tag === 's') {
                    return <span key="system-tag" style={{ color: '#aaa' }}>系统类型</span>;
                }
                return [
                    <a key="edit-action" onClick={() => action?.startEditable?.(record.key)}>
                        编辑
                    </a>,
                    <Popconfirm
                        key="delete-confirm"
                        title="确定删除吗？"
                        onConfirm={() => handleDelete(record)}
                    >
                        <a key="delete-action">删除</a>
                    </Popconfirm>
                ];
            },
        }
    ];

    return (
        <>
            <a onClick={() => { setOpen(true) }}>设置报销类型</a>
            <Modal
                open={open}
                title='设置报销类型'
                onOk={() => setOpen(false)}
                footer={null}
                onCancel={() => { setOpen(false) }}
                width={800}
            >
                <EditableProTable
                    rowKey="key"
                    actionRef={actionRef}
                    columns={columns}
                    value={dataSource}
                    onChange={setDataSource}
                    editable={{
                        form,
                        editableKeys,
                        onSave: async (rowKey, data, row) => {
                            try {
                                const original = row.originalData;
                                if (original) {
                                    // 更新操作
                                    await updateSave({
                                        fyt_id: original.fyt_id,
                                        fyt_name: data.title,
                                        fyt_qy_id: props.e_id,
                                        fyt_tag: original.fyt_tag,
                                        fyt_uid: props.eu_id,
                                        fyt_uname: props.eu_name,
                                    });
                                    message.success('修改成功！');
                                } else {
                                    // 新增操作
                                    await add({
                                        fyt_name: data.title,
                                        fyt_tag: '',
                                        fyt_qy_id: props.e_id,
                                        fyt_uid: props.eu_id,
                                        fyt_uname: props.eu_name,
                                    });
                                    message.success('新建成功！');
                                }
                                refetch();
                            } catch (error) {
                                message.error('操作失败: ' + error.message);
                            }
                        },
                        onChange: setEditableRowKeys,
                        actionRender: (row, config, defaultDom) => {
                            return [defaultDom.save, defaultDom.cancel];
                        },
                    }}
                    recordCreatorProps={{
                        position: 'bottom',
                        record: () => ({ 
                            key: Date.now().toString(),
                            title: '',
                        }),
                        creatorButtonText: '新增报销类型',
                        style: { backgroundColor: "#1890ff", color: '#fff' },
                    }}
                />
            </Modal>
        </>
    )
}

export default ExpenseTypeEdit
